export default __webpack_public_path__ + "static/media/ams-family.85b80ada.png";